import React from 'react';

import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {translations} from 'presentation/translations-new';
import {BookingFlowLayout} from '../../components/BookingFlowLayout';

import {EXAMS_LABELS, EXAMS_LABELS_WITHOUT_DISTRICT} from './constants';
import {useBackButtonBooking} from 'presentation/modules/booking/shared/hooks/useBackButtonBooking';
import {BookingTypeEnum} from 'presentation/modules/booking/shared/constants/bookingTypeEnum';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

const {bookExams} = translations['pt-br'].privateFlow.services;

export function ExamBooking() {
	const bookingData = useBookingStore(state => state.bookingData);
	const isUsingGeolocation = !bookingData.isManualLocation;
	useBackButtonBooking({flowType: BookingTypeEnum.EXAM});

	return (
		<BookingFlowLayout
			flowType={FlowEnum.EXAM}
			headerTitle={bookExams}
			stepLabels={isUsingGeolocation ? EXAMS_LABELS_WITHOUT_DISTRICT : EXAMS_LABELS}
		/>
	);
}
